﻿namespace WebPortal.Default {
    export class Accordion {
        public static GetAccordionElement(_ID: number, _Title: string, _Message: string, _AccordionName: string): JQuery {
            let Expanded: boolean = false;
            let ExpandedStr: string = "";
            if (_ID == 0) {
                Expanded = true;
                ExpandedStr = " in";
            }

            var PatternFile = /\[FILE\]([\w\(\)\s\.\/\-]+)\[\/FILE\]/gi;
            let ReplacementFile: string = "<a target=\"_blank\" href=\"/spannedremasdata/$1\">$1</a>";
            _Message = _Message.replace(PatternFile, ReplacementFile);
            var PatternImg = /\[IMG\]([\w\(\)\s\.\/\-]+)\[\/IMG\]/gi;
            let ReplacementImg: string = "<img alt=\"$1\" src=\"/spannedremasdata/$1\" />";
            _Message = _Message.replace(PatternImg, ReplacementImg);

            return $("<div/>")
                .attr({
                    "id": "pn_Accordion_Element_" + _AccordionName + "_" + _ID,
                    "class": "panel panel-default Accordion_Element_" + _AccordionName,
                })
                .append(
                    $("<div/>")
                        .attr({
                            "id": "pn_Accordion_Element_Heading_" + _AccordionName + "_" + _ID,
                            "class": "panel-heading",
                            "role": "tab",
                        })
                        .append(
                            $("<h4/>")
                                .attr({
                                    "class": "panel-title",
                                })
                                .append(
                                    $("<a/>")
                                        .attr({
                                            "role": "button",
                                            "data-toggle": "collapse",
                                            "data-parent": "#ac_" + _AccordionName,
                                            "href": "#pn_Accordion_Element_Collapse_" + _AccordionName + "_" + _ID,
                                            "aria-expanded": Expanded,
                                            "aria-controls": "pn_Accordion_Element_Collapse_" + _AccordionName + "_" + _ID,
                                        }).text(_Title)
                                )
                        )
                )
                .append(
                    $("<div/>")
                        .attr({
                            "id": "pn_Accordion_Element_Collapse_" + _AccordionName + "_" + _ID,
                            "class": "panel-collapse collapse" + ExpandedStr,
                            "role": "tabpanel",
                            "aria-labelledby": "pn_Accordion_Element_Heading_" + _AccordionName + "_" + _ID,
                        })
                        .append(
                            $("<div/>")
                                .attr({
                                    "class": "panel-body",
                                }).append(_Message)
                        )
                );
        }

        public static FilterAccordion(_SearchValue: string, _AccordionName: string) {
            $(".Accordion_Element_" + _AccordionName)
                .each((index: number, elem: any) => {
                    let TitleStr: string = $(elem).find("h4").first().text().toLowerCase();
                    let MessageStr: string = $(elem).find(".panel-body").first().text().toLowerCase();
                    if ((!(!!_SearchValue)) || (TitleStr.indexOf(_SearchValue.toLowerCase()) > -1) || (MessageStr.indexOf(_SearchValue.toLowerCase()) > -1)) {
                        $(elem).show();
                    } else {
                        $(elem).hide();
                    }
                });
        }
    }
}